module.exports = __webpack_public_path__ + "img/cx.e01cb23f.png";